function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-underscore-dangle */
/* eslint class-methods-use-this: "off" */
import memoize from 'memoize-one';
import throttle from 'lodash.throttle';
import { GridRange, GridUtils, memoizeClear } from '@deephaven/grid';
import Log from '@deephaven/log';
import { EventShimCustomEvent, PromiseUtils, assertNotNull } from '@deephaven/utils';
import { TableUtils, Formatter, FormatterUtils, DateUtils } from '@deephaven/jsapi-utils';
import IrisGridModel from "./IrisGridModel.js";
import AggregationOperation from "./sidebar/aggregations/AggregationOperation.js";
import IrisGridUtils from "./IrisGridUtils.js";
import MissingKeyError from "./MissingKeyError.js";
import { isColumnHeaderGroup } from "./ColumnHeaderGroup.js";
import { GridCommitError } from "./GridCommitError.js";
var log = Log.module('IrisGridTableModelTemplate');
var SET_VIEWPORT_THROTTLE = 150;
var APPLY_VIEWPORT_THROTTLE = 0;
export function isIrisGridTableModelTemplate(model) {
  return model.table !== undefined;
}

/**
 * Template model for a grid
 */

class IrisGridTableModelTemplate extends IrisGridModel {
  seekRow(startRow, column, valueType, value, insensitive, contains, isBackwards) {
    throw new Error('Method not implemented.');
  }
  export() {
    throw new Error('Method not implemented.');
  }
  columnStatistics(column) {
    throw new Error('Method not implemented.');
  }
  get customColumns() {
    return [];
  }
  set customColumns(customColumns) {
    throw new Error('Method not implemented.');
  }
  get formatColumns() {
    return [];
  }
  set formatColumns(formatColumns) {
    throw new Error('Method not implemented.');
  }
  updateFrozenColumns(columns) {
    throw new Error('Method not implemented.');
  }
  get rollupConfig() {
    throw new Error('Method not implemented.');
  }
  set rollupConfig(rollupConfig) {
    throw new Error('Method not implemented.');
  }
  get selectDistinctColumns() {
    throw new Error('Method not implemented.');
  }
  set selectDistinctColumns(names) {
    throw new Error('Method not implemented.');
  }

  /**
   * Returns an array of the columns in the model
   * The order of model columns should never change once established
   */
  get columns() {
    return this.table.columns;
  }
  /**
   * @param dh JSAPI instance
   * @param table Iris data table to be used in the model
   * @param formatter The formatter to use when getting formats
   * @param inputTable Iris input table associated with this table
   * @param columnAlignmentMap Map of column alignments
   */
  constructor(dh, table) {
    var _formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Formatter(dh);
    var inputTable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var columnAlignmentMap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Map();
    super(dh);
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "irisGridUtils", void 0);
    _defineProperty(this, "tableUtils", void 0);
    _defineProperty(this, "irisFormatter", void 0);
    _defineProperty(this, "irisColumnAlignmentMap", void 0);
    _defineProperty(this, "inputTable", void 0);
    _defineProperty(this, "subscription", void 0);
    _defineProperty(this, "table", void 0);
    _defineProperty(this, "viewport", void 0);
    _defineProperty(this, "viewportData", void 0);
    _defineProperty(this, "formattedStringData", void 0);
    _defineProperty(this, "pendingStringData", void 0);
    _defineProperty(this, "isSaveInProgress", void 0);
    _defineProperty(this, "totalsTable", void 0);
    _defineProperty(this, "totalsTablePromise", void 0);
    _defineProperty(this, "totals", void 0);
    _defineProperty(this, "totalsDataMap", void 0);
    // Map from new row index to their values. Only for input tables that can have new rows added.
    // The index of these rows start at 0, and they are appended at the end of the regular table data.
    // These rows can be sparse, so using a map instead of an array.
    _defineProperty(this, "pendingNewDataMap", void 0);
    _defineProperty(this, "pendingNewRowCount", 0);
    _defineProperty(this, "_columnHeaderGroupMap", new Map());
    _defineProperty(this, "columnHeaderParentMap", new Map());
    _defineProperty(this, "_columnHeaderMaxDepth", null);
    _defineProperty(this, "_columnHeaderGroups", []);
    _defineProperty(this, "_isColumnHeaderGroupsInitialized", false);
    _defineProperty(this, "_movedColumns", null);
    _defineProperty(this, "getMemoizedInitialMovedColumns", memoize(layoutHints => {
      var _layoutHints$columnGr, _layoutHints$frontCol, _layoutHints$backColu, _layoutHints$frozenCo;
      if (!layoutHints) {
        return [];
      }
      var movedColumns = [];
      var _IrisGridUtils$parseC = IrisGridUtils.parseColumnHeaderGroups(this, (_layoutHints$columnGr = layoutHints === null || layoutHints === void 0 ? void 0 : layoutHints.columnGroups) !== null && _layoutHints$columnGr !== void 0 ? _layoutHints$columnGr : []),
        groupMap = _IrisGridUtils$parseC.groupMap;
      var moveColumn = (name, toIndex) => {
        var modelIndex = this.getColumnIndexByName(name);
        if (modelIndex == null) {
          throw new Error("Unknown layout hint column: ".concat(name));
        }
        var visibleIndex = GridUtils.getVisibleIndex(modelIndex, movedColumns);
        movedColumns = GridUtils.moveItem(visibleIndex, toIndex, movedColumns);
      };
      var moveGroup = (name, toIndex) => {
        var group = groupMap.get(name);
        if (group == null) {
          throw new Error("Unknown layout hint group: ".concat(name));
        }
        var visibleRange = group.getVisibleRange(movedColumns);
        movedColumns = GridUtils.moveRange(visibleRange, toIndex, movedColumns);
      };
      var frontColumns = (_layoutHints$frontCol = layoutHints.frontColumns) !== null && _layoutHints$frontCol !== void 0 ? _layoutHints$frontCol : [];
      var backColumns = (_layoutHints$backColu = layoutHints.backColumns) !== null && _layoutHints$backColu !== void 0 ? _layoutHints$backColu : [];
      var frozenColumns = (_layoutHints$frozenCo = layoutHints.frozenColumns) !== null && _layoutHints$frozenCo !== void 0 ? _layoutHints$frozenCo : [];
      if (frontColumns.length > 0 || backColumns.length > 0 || frozenColumns.length > 0) {
        var usedColumns = new Set();
        var frontIndex = 0;
        frozenColumns === null || frozenColumns === void 0 || frozenColumns.forEach(name => {
          if (usedColumns.has(name)) {
            throw new Error("Column specified in multiple layout hints: ".concat(name));
          }
          moveColumn(name, frontIndex);
          frontIndex += 1;
        });
        frontColumns.forEach(name => {
          if (usedColumns.has(name)) {
            throw new Error("Column specified in multiple layout hints: ".concat(name));
          }
          moveColumn(name, frontIndex);
          frontIndex += 1;
        });
        var backIndex = this.columns.length - 1;
        backColumns === null || backColumns === void 0 || backColumns.forEach(name => {
          if (usedColumns.has(name)) {
            throw new Error("Column specified in multiple layout hints: ".concat(name));
          }
          moveColumn(name, backIndex);
          backIndex -= 1;
        });
      }
      var layoutHintColumnGroups = layoutHints === null || layoutHints === void 0 ? void 0 : layoutHints.columnGroups;
      if (layoutHintColumnGroups) {
        var columnGroups = [...groupMap.values()];
        columnGroups.sort((a, b) => a.depth - b.depth);
        columnGroups.forEach(group => {
          var firstChildName = group.children[0];
          var rightModelIndex = this.getColumnIndexByName(firstChildName);
          var rightVisibleIndex;
          if (rightModelIndex != null) {
            rightVisibleIndex = GridUtils.getVisibleIndex(rightModelIndex, movedColumns);
          } else {
            var firstChildGroup = groupMap.get(firstChildName);
            if (!firstChildGroup) {
              throw new Error("Unknown column ".concat(firstChildName, " in group ").concat(group.name));
            }
            var visibleRange = firstChildGroup.getVisibleRange(movedColumns);
            // Columns will be moved to start at the end of the first child group
            var _visibleRange = _slicedToArray(visibleRange, 2);
            rightVisibleIndex = _visibleRange[1];
          }
          for (var i = 1; i < group.children.length; i += 1) {
            var childName = group.children[i];
            var childGroup = groupMap.get(childName);
            var childColumn = this.getColumnIndexByName(childName);
            if (childGroup) {
              // All columns in the group will be before or after the start index
              // Lower level groups are re-arranged first, so they will be contiguous
              var isBeforeGroup = childGroup.getVisibleRange(movedColumns)[0] < rightVisibleIndex;
              var moveToIndex = isBeforeGroup ? rightVisibleIndex - childGroup.childIndexes.length + 1 : rightVisibleIndex + 1;
              moveGroup(childName, moveToIndex);
              rightVisibleIndex = moveToIndex + childGroup.childIndexes.length - 1;
            } else if (childColumn != null) {
              var _isBeforeGroup = GridUtils.getVisibleIndex(childColumn, movedColumns) < rightVisibleIndex;
              var _moveToIndex = _isBeforeGroup ? rightVisibleIndex : rightVisibleIndex + 1;
              moveColumn(childName, _moveToIndex);
              rightVisibleIndex = _moveToIndex;
            }
          }
        });
      }
      this._movedColumns = movedColumns;
      return movedColumns;
    }));
    _defineProperty(this, "getMemoizedInitialColumnHeaderGroups", memoize(layoutHints => {
      var _layoutHints$columnGr2;
      return IrisGridUtils.parseColumnHeaderGroups(this, (_layoutHints$columnGr2 = layoutHints === null || layoutHints === void 0 ? void 0 : layoutHints.columnGroups) !== null && _layoutHints$columnGr2 !== void 0 ? _layoutHints$columnGr2 : []).groups;
    }));
    _defineProperty(this, "getColumnIndicesByNameMap", memoize(columns => {
      var indices = new Map();
      columns.forEach((_ref, i) => {
        var name = _ref.name;
        return indices.set(name, i);
      });
      return indices;
    }));
    _defineProperty(this, "setViewport", throttle((top, bottom, columns) => {
      if (bottom < top) {
        log.error('Invalid viewport', top, bottom);
        return;
      }
      var viewport = this.viewport;
      if (viewport != null && viewport.top === top && viewport.bottom === bottom && viewport.columns === columns) {
        log.debug2('Ignoring duplicate viewport', viewport);
        return;
      }
      this.viewport = {
        top,
        bottom,
        columns
      };
      log.debug2('setViewport', this.viewport);
      this.applyViewport();
    }, SET_VIEWPORT_THROTTLE));
    /**
     * Applies the current viewport to the underlying table.
     */
    _defineProperty(this, "applyViewport", throttle(() => {
      if (!this.viewport) {
        return;
      }
      log.debug2('applyViewport', this.viewport);
      var _this$viewport = this.viewport,
        top = _this$viewport.top,
        bottom = _this$viewport.bottom,
        columns = _this$viewport.columns;
      var _this$getCachedViewpo = this.getCachedViewportRowRange(top, bottom),
        _this$getCachedViewpo2 = _slicedToArray(_this$getCachedViewpo, 2),
        viewportTop = _this$getCachedViewpo2[0],
        viewportBottom = _this$getCachedViewpo2[1];
      this.applyBufferedViewport(viewportTop, viewportBottom, columns);
    }, APPLY_VIEWPORT_THROTTLE, {
      leading: false
    }));
    _defineProperty(this, "getCachedFormattedString", memoizeClear((formatter, value, columnType, columnName, formatOverride) => formatter.getFormattedString(value, columnType, columnName, formatOverride), {
      max: 10000
    }));
    _defineProperty(this, "getCachedCustomColumnFormatFlag", memoizeClear(FormatterUtils.isCustomColumnFormatDefined, {
      max: 10000
    }));
    _defineProperty(this, "getCachedViewportRowRange", memoize((top, bottom) => {
      var viewHeight = bottom - top;
      var viewportTop = Math.max(0, top - viewHeight * IrisGridTableModelTemplate.ROW_BUFFER_PAGES);
      var viewportBottom = bottom + viewHeight * IrisGridTableModelTemplate.ROW_BUFFER_PAGES;
      return [viewportTop, viewportBottom];
    }));
    _defineProperty(this, "getCachedPendingErrors", memoize((pendingDataMap, columns, keyColumnCount) => {
      var map = new Map();
      pendingDataMap.forEach((row, rowIndex) => {
        var rowData = row.data;
        for (var i = 0; i < keyColumnCount; i += 1) {
          if (!rowData.has(i)) {
            var _map$get;
            if (!map.has(rowIndex)) {
              map.set(rowIndex, []);
            }
            (_map$get = map.get(rowIndex)) === null || _map$get === void 0 || _map$get.push(new MissingKeyError(rowIndex, columns[i].name));
          }
        }
      });
      return map;
    }));
    this.handleTableDisconnect = this.handleTableDisconnect.bind(this);
    this.handleTableReconnect = this.handleTableReconnect.bind(this);
    this.handleTableUpdate = this.handleTableUpdate.bind(this);
    this.handleTotalsUpdate = this.handleTotalsUpdate.bind(this);
    this.handleRequestFailed = this.handleRequestFailed.bind(this);
    this.handleCustomColumnsChanged = this.handleCustomColumnsChanged.bind(this);
    this.dh = dh;
    this.irisFormatter = _formatter;
    this.irisColumnAlignmentMap = columnAlignmentMap;
    this.irisGridUtils = new IrisGridUtils(dh);
    this.inputTable = inputTable;
    this.subscription = null;
    this.table = table;
    this.tableUtils = new TableUtils(dh);
    this.viewport = null;
    this.viewportData = null;
    this.formattedStringData = [];
    this.pendingStringData = [];
    this.isSaveInProgress = false;
    this.totalsTable = null;
    this.totalsTablePromise = null;
    this.totals = null;
    this.totalsDataMap = null;

    // Map from new row index to their values. Only for input tables that can have new rows added.
    // The index of these rows start at 0, and they are appended at the end of the regular table data.
    // These rows can be sparse, so using a map instead of an array.
    this.pendingNewDataMap = new Map();
    this.pendingNewRowCount = 0;
  }
  close() {
    this.table.close();
    if (this.totalsTable !== null) {
      this.totalsTable.close();
    }
    if (this.totalsTablePromise !== null) {
      this.totalsTablePromise.cancel();
    }
  }
  startListening() {
    super.startListening();
    var dh = this.dh;
    this.table.addEventListener(dh.Table.EVENT_DISCONNECT, this.handleTableDisconnect);
    this.table.addEventListener(dh.Table.EVENT_RECONNECT, this.handleTableReconnect);
    this.table.addEventListener(dh.Table.EVENT_UPDATED, this.handleTableUpdate);
    this.table.addEventListener(dh.Client.EVENT_REQUEST_FAILED, this.handleRequestFailed);
    this.table.addEventListener(dh.Table.EVENT_CUSTOMCOLUMNSCHANGED, this.handleCustomColumnsChanged);
    if (this.totalsTable != null) {
      this.addTotalsListeners(this.totalsTable);
    }
    this.applyViewport();
  }
  stopListening() {
    super.stopListening();
    var dh = this.dh;
    this.table.removeEventListener(dh.Table.EVENT_DISCONNECT, this.handleTableDisconnect);
    this.table.removeEventListener(dh.Table.EVENT_RECONNECT, this.handleTableReconnect);
    this.table.removeEventListener(dh.Table.EVENT_UPDATED, this.handleTableUpdate);
    this.table.removeEventListener(dh.Client.EVENT_REQUEST_FAILED, this.handleRequestFailed);
    this.table.removeEventListener(dh.Table.EVENT_CUSTOMCOLUMNSCHANGED, this.handleCustomColumnsChanged);
    if (this.totalsTable != null) {
      this.removeTotalsListeners(this.totalsTable);
    }
    this.closeSubscription();
  }
  addTotalsListeners(totalsTable) {
    var dh = this.dh;
    totalsTable.addEventListener(dh.Table.EVENT_UPDATED, this.handleTotalsUpdate);

    // Totals table only has one row of data
    totalsTable.setViewport(0, 0);
  }
  removeTotalsListeners(totalsTable) {
    var dh = this.dh;
    totalsTable.removeEventListener(dh.Table.EVENT_UPDATED, this.handleTotalsUpdate);
  }
  handleTableDisconnect() {
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.DISCONNECT));
  }
  handleTableReconnect() {
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.RECONNECT));
  }
  handleTableUpdate(event) {
    this.copyViewportData(event.detail);
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));
  }
  handleTotalsUpdate(event) {
    this.copyTotalsData(event.detail);
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));
  }
  handleRequestFailed(event) {
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.REQUEST_FAILED, event));
  }
  handleCustomColumnsChanged() {
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.COLUMNS_CHANGED, {
      detail: this.columns
    }));
  }
  get rowCount() {
    var _this$totals$operatio, _this$totals;
    return (
      // Table size can be negative if the table isn't ready yet
      Math.max(this.table.size, 0) + this.pendingNewRowCount + ((_this$totals$operatio = (_this$totals = this.totals) === null || _this$totals === void 0 || (_this$totals = _this$totals.operationOrder) === null || _this$totals === void 0 ? void 0 : _this$totals.length) !== null && _this$totals$operatio !== void 0 ? _this$totals$operatio : 0)
    );
  }
  get pendingDataErrors() {
    var _this$inputTable$keyC, _this$inputTable;
    return this.getCachedPendingErrors(this.pendingNewDataMap, this.columns, (_this$inputTable$keyC = (_this$inputTable = this.inputTable) === null || _this$inputTable === void 0 ? void 0 : _this$inputTable.keyColumns.length) !== null && _this$inputTable$keyC !== void 0 ? _this$inputTable$keyC : 0);
  }
  get pendingDataMap() {
    return this.pendingNewDataMap;
  }
  set pendingDataMap(map) {
    if (map === this.pendingNewDataMap) {
      return;
    }
    map.forEach((row, rowIndex) => {
      if (!IrisGridUtils.isValidIndex(rowIndex)) {
        throw new Error("Invalid rowIndex ".concat(rowIndex));
      }
      var data = row.data;
      data.forEach((value, columnIndex) => {
        if (!IrisGridUtils.isValidIndex(columnIndex)) {
          throw new Error("Invalid columnIndex ".concat(columnIndex));
        }
      });
    });
    this.pendingNewDataMap = map;
    this.pendingNewRowCount = Math.max(this.pendingNewRowCount, this.maxPendingDataRow);
    this.formattedStringData = [];
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.PENDING_DATA_UPDATED));
  }
  get pendingRowCount() {
    return this.pendingNewRowCount;
  }
  set pendingRowCount(count) {
    if (count === this.pendingNewRowCount) {
      return;
    }
    this.pendingNewRowCount = Math.max(0, count, this.maxPendingDataRow);
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));
  }
  get maxPendingDataRow() {
    return this.pendingNewDataMap.size > 0 ? Math.max(...this.pendingNewDataMap.keys()) + 1 : 0;
  }
  get columnCount() {
    return this.columns.length;
  }
  get floatingBottomRowCount() {
    var _this$totals$operatio2, _this$totals2;
    return this.totals != null && this.totals.showOnTop ? 0 : (_this$totals$operatio2 = (_this$totals2 = this.totals) === null || _this$totals2 === void 0 || (_this$totals2 = _this$totals2.operationOrder) === null || _this$totals2 === void 0 ? void 0 : _this$totals2.length) !== null && _this$totals$operatio2 !== void 0 ? _this$totals$operatio2 : 0;
  }
  get floatingTopRowCount() {
    var _this$totals$operatio3, _this$totals3;
    return this.totals != null && this.totals.showOnTop ? (_this$totals$operatio3 = (_this$totals3 = this.totals) === null || _this$totals3 === void 0 || (_this$totals3 = _this$totals3.operationOrder) === null || _this$totals3 === void 0 ? void 0 : _this$totals3.length) !== null && _this$totals$operatio3 !== void 0 ? _this$totals$operatio3 : 0 : 0;
  }
  get isValuesTableAvailable() {
    return this.table.selectDistinct != null && this.table.copy != null;
  }
  get isChartBuilderAvailable() {
    return true;
  }
  get isOrganizeColumnsAvailable() {
    return true;
  }
  get isTotalsAvailable() {
    return this.table.getTotalsTable != null;
  }
  get isEditable() {
    return !this.isSaveInProgress && this.inputTable != null;
  }
  get isDeletable() {
    return this.keyColumnSet.size > 0;
  }
  get isViewportPending() {
    if (this.viewport == null || this.viewport.columns === undefined || this.viewportData == null) {
      return true;
    }
    // no columns or no rows
    if (this.viewport.columns.length === 0 || this.viewportData.rows.length === 0) {
      return false;
    }

    // offset is first row of loaded data
    var pendingTop = this.viewport.top < this.viewportData.offset;
    // offset + row.length is last row of loaded data
    var pendingBottom = this.viewportData.offset + this.viewportData.rows.length < this.viewport.bottom;
    // left column doesn't exist in data
    var pendingLeft = this.viewportData.rows[0].data.get(this.viewport.columns[0].index) === undefined;
    // right column doesn't exist in data
    var pendingRight = this.viewportData.rows[0].data.get(this.viewport.columns[this.viewport.columns.length - 1].index) === undefined;
    return pendingTop || pendingBottom || pendingLeft || pendingRight;
  }
  cacheFormattedValue(x, y, text) {
    if (this.formattedStringData[x] == null) {
      this.formattedStringData[x] = [];
    }
    this.formattedStringData[x][y] = text;
  }
  cachePendingValue(x, y, text) {
    if (this.pendingStringData[x] == null) {
      this.pendingStringData[x] = [];
    }
    this.pendingStringData[x][y] = text;
  }
  clearPendingValue(x, y) {
    var column = this.pendingStringData[x];
    if (column != null) {
      delete column[y];
    }
  }
  textValueForCell(x, y) {
    var _this$pendingStringDa, _this$formattedString;
    // First check if there's any pending values we should read from
    if (((_this$pendingStringDa = this.pendingStringData[x]) === null || _this$pendingStringDa === void 0 ? void 0 : _this$pendingStringDa[y]) !== undefined) {
      return this.pendingStringData[x][y];
    }

    // Use a separate cache from memoization just for the strings that are currently displayed
    if (((_this$formattedString = this.formattedStringData[x]) === null || _this$formattedString === void 0 ? void 0 : _this$formattedString[y]) === undefined) {
      var value = this.valueForCell(x, y);
      if (value === null) {
        return null;
      }
      if (value === undefined) {
        return undefined;
      }
      var column = this.sourceColumn(x, y);
      var hasCustomColumnFormat = this.getCachedCustomColumnFormatFlag(this.formatter, column.name, column.type);
      var formatOverride;
      if (!hasCustomColumnFormat) {
        var formatForCell = this.formatForCell(x, y);
        if ((formatForCell === null || formatForCell === void 0 ? void 0 : formatForCell.formatString) != null) {
          formatOverride = formatForCell;
        }
      }
      var text = this.displayString(value, column.type, column.name, formatOverride);
      this.cacheFormattedValue(x, y, text);
    }
    return this.formattedStringData[x][y];
  }
  textForCell(x, y) {
    var _this$columns$x;
    var text = this.textValueForCell(x, y);
    if (text == null && this.isKeyColumn(x)) {
      var pendingRow = this.pendingRow(y);
      if (pendingRow != null && this.pendingDataMap.has(pendingRow)) {
        // Asterisk to show a value is required for a key column on a row that has some data entered
        return '*';
      }
    }
    if (TableUtils.isTextType((_this$columns$x = this.columns[x]) === null || _this$columns$x === void 0 ? void 0 : _this$columns$x.type)) {
      if (text === null) {
        return this.formatter.showNullStrings ? 'null' : '';
      }
      if (text === '') {
        return this.formatter.showEmptyStrings ? 'empty' : '';
      }
    }
    return text !== null && text !== void 0 ? text : '';
  }
  truncationCharForCell(x) {
    var column = this.columns[x];
    var type = column.type;
    if (TableUtils.isNumberType(type) && this.formatter.truncateNumbersWithPound) {
      return '#';
    }
    return undefined;
  }
  colorForCell(x, y, theme) {
    var data = this.dataForCell(x, y);
    if (data) {
      var format = data.format,
        value = data.value;
      if (value == null || value === '') {
        assertNotNull(theme.nullStringColor);
        return theme.nullStringColor;
      }
      if ((format === null || format === void 0 ? void 0 : format.color) != null && format.color !== '') {
        return format.color;
      }
      if (this.isPendingRow(y)) {
        // Data entered in a pending row
        assertNotNull(theme.pendingTextColor);
        return theme.pendingTextColor;
      }

      // Fallback to formatting based on the value/type of the cell
      if (value != null) {
        var column = this.sourceColumn(x, y);
        return IrisGridUtils.colorForValue(theme, column.type, column.name, value);
      }
    } else if (this.isPendingRow(y) && this.isKeyColumn(x)) {
      assertNotNull(theme.errorTextColor);
      return theme.errorTextColor;
    }
    return theme.textColor;
  }
  backgroundColorForCell(x, y, theme) {
    var _this$formatForCell$b, _this$formatForCell;
    return (_this$formatForCell$b = (_this$formatForCell = this.formatForCell(x, y)) === null || _this$formatForCell === void 0 ? void 0 : _this$formatForCell.backgroundColor) !== null && _this$formatForCell$b !== void 0 ? _this$formatForCell$b : null;
  }
  textAlignForCell(x, y) {
    var column = this.sourceColumn(x, y);
    var userTextAlignment = this.columnAlignmentMap.get(column.name);
    if (userTextAlignment != null) {
      return userTextAlignment;
    }
    return IrisGridUtils.textAlignForValue(column.type, column.name);
  }
  textForColumnHeader(x) {
    var _header$displayName;
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var header = this.columnAtDepth(x, depth);
    if (isColumnHeaderGroup(header)) {
      return header.isNew ? '' : header.name;
    }
    return (_header$displayName = header === null || header === void 0 ? void 0 : header.displayName) !== null && _header$displayName !== void 0 ? _header$displayName : header === null || header === void 0 ? void 0 : header.name;
  }
  colorForColumnHeader(x) {
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var column = this.columnAtDepth(x, depth);
    if (isColumnHeaderGroup(column)) {
      var _column$color;
      return (_column$color = column.color) !== null && _column$color !== void 0 ? _column$color : null;
    }
    return null;
  }
  tooltipForCell(column, row) {
    if (TableUtils.isDateType(this.columns[column].type)) {
      return this.displayString(this.valueForCell(column, row), this.columns[column].type, this.columns[column].name, {
        formatString: DateUtils.FULL_DATE_FORMAT
      });
    }
    return null;
  }
  getColumnHeaderGroup(modelIndex, depth) {
    var group = this.columnAtDepth(modelIndex, depth);
    if (isColumnHeaderGroup(group)) {
      return group;
    }
    return undefined;
  }
  getColumnHeaderParentGroup(modelIndex, depth) {
    var _this$columnAtDepth$n, _this$columnAtDepth;
    return this.columnHeaderParentMap.get((_this$columnAtDepth$n = (_this$columnAtDepth = this.columnAtDepth(modelIndex, depth)) === null || _this$columnAtDepth === void 0 ? void 0 : _this$columnAtDepth.name) !== null && _this$columnAtDepth$n !== void 0 ? _this$columnAtDepth$n : '');
  }
  columnAtDepth(x) {
    var _this$columns$x2;
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (depth === 0) {
      return this.columns[x];
    }
    var columnName = (_this$columns$x2 = this.columns[x]) === null || _this$columns$x2 === void 0 ? void 0 : _this$columns$x2.name;
    var group = this.columnHeaderParentMap.get(columnName);
    if (!group) {
      return undefined;
    }
    var currentDepth = group.depth;
    while (currentDepth < depth) {
      group = this.columnHeaderParentMap.get(group.name);
      if (!group) {
        return undefined;
      }
      currentDepth = group.depth;
    }
    if (group.depth === depth) {
      return group;
    }
    return undefined;
  }
  textForRowFooter(y) {
    var totalsRow = this.totalsRow(y);
    if (totalsRow != null && this.totals) {
      return this.totals.operationOrder[totalsRow];
    }
    return '';
  }
  /**
   * Used to get the initial moved columns based on layout hints
   */
  get initialMovedColumns() {
    var _this$layoutHints;
    return this.getMemoizedInitialMovedColumns((_this$layoutHints = this.layoutHints) !== null && _this$layoutHints !== void 0 ? _this$layoutHints : undefined);
  }
  get initialColumnHeaderGroups() {
    var _this$layoutHints2;
    return this.getMemoizedInitialColumnHeaderGroups((_this$layoutHints2 = this.layoutHints) !== null && _this$layoutHints2 !== void 0 ? _this$layoutHints2 : undefined);
  }
  get columnHeaderMaxDepth() {
    var _this$_columnHeaderMa;
    return (_this$_columnHeaderMa = this._columnHeaderMaxDepth) !== null && _this$_columnHeaderMa !== void 0 ? _this$_columnHeaderMa : 1;
  }
  set columnHeaderMaxDepth(depth) {
    this._columnHeaderMaxDepth = depth;
  }
  get columnHeaderGroupMap() {
    this.initializeColumnHeaderGroups();
    return this._columnHeaderGroupMap;
  }
  get columnHeaderGroups() {
    this.initializeColumnHeaderGroups();
    return this._columnHeaderGroups;
  }
  set columnHeaderGroups(groups) {
    if (groups === this._columnHeaderGroups) {
      return;
    }
    var _IrisGridUtils$parseC2 = IrisGridUtils.parseColumnHeaderGroups(this, groups !== null && groups !== void 0 ? groups : this.initialColumnHeaderGroups),
      newGroups = _IrisGridUtils$parseC2.groups,
      maxDepth = _IrisGridUtils$parseC2.maxDepth,
      parentMap = _IrisGridUtils$parseC2.parentMap,
      groupMap = _IrisGridUtils$parseC2.groupMap;
    this._columnHeaderGroups = newGroups;
    this.columnHeaderMaxDepth = maxDepth;
    this.columnHeaderParentMap = parentMap;
    this._columnHeaderGroupMap = groupMap;
    this._isColumnHeaderGroupsInitialized = true;
  }
  initializeColumnHeaderGroups() {
    if (!this._isColumnHeaderGroupsInitialized) {
      var _this$layoutHints$col, _this$layoutHints3;
      this.columnHeaderGroups = IrisGridUtils.parseColumnHeaderGroups(this, (_this$layoutHints$col = (_this$layoutHints3 = this.layoutHints) === null || _this$layoutHints3 === void 0 ? void 0 : _this$layoutHints3.columnGroups) !== null && _this$layoutHints$col !== void 0 ? _this$layoutHints$col : []).groups;
    }
  }
  row(y) {
    var _this$totals$operatio4, _this$totals4, _this$totals$showOnTo, _this$totals5, _this$viewportData$of, _this$viewportData, _this$viewportData$ro, _this$viewportData2;
    var totalsRowCount = (_this$totals$operatio4 = (_this$totals4 = this.totals) === null || _this$totals4 === void 0 || (_this$totals4 = _this$totals4.operationOrder) === null || _this$totals4 === void 0 ? void 0 : _this$totals4.length) !== null && _this$totals$operatio4 !== void 0 ? _this$totals$operatio4 : 0;
    var showOnTop = (_this$totals$showOnTo = (_this$totals5 = this.totals) === null || _this$totals5 === void 0 ? void 0 : _this$totals5.showOnTop) !== null && _this$totals$showOnTo !== void 0 ? _this$totals$showOnTo : false;
    var totalsRow = this.totalsRow(y);
    if (totalsRow != null) {
      var _this$totals6, _this$totalsDataMap$g, _this$totalsDataMap;
      var operation = (_this$totals6 = this.totals) === null || _this$totals6 === void 0 ? void 0 : _this$totals6.operationOrder[totalsRow];
      assertNotNull(operation);
      return (_this$totalsDataMap$g = (_this$totalsDataMap = this.totalsDataMap) === null || _this$totalsDataMap === void 0 ? void 0 : _this$totalsDataMap.get(operation)) !== null && _this$totalsDataMap$g !== void 0 ? _this$totalsDataMap$g : null;
    }
    var pendingRow = this.pendingRow(y);
    if (pendingRow != null) {
      var _this$pendingNewDataM;
      return (_this$pendingNewDataM = this.pendingNewDataMap.get(pendingRow)) !== null && _this$pendingNewDataM !== void 0 ? _this$pendingNewDataM : null;
    }
    var offset = (_this$viewportData$of = (_this$viewportData = this.viewportData) === null || _this$viewportData === void 0 ? void 0 : _this$viewportData.offset) !== null && _this$viewportData$of !== void 0 ? _this$viewportData$of : 0;
    var viewportY = (showOnTop ? y - totalsRowCount : y) - offset;
    return (_this$viewportData$ro = (_this$viewportData2 = this.viewportData) === null || _this$viewportData2 === void 0 || (_this$viewportData2 = _this$viewportData2.rows) === null || _this$viewportData2 === void 0 ? void 0 : _this$viewportData2[viewportY]) !== null && _this$viewportData$ro !== void 0 ? _this$viewportData$ro : null;
  }

  /**
   * Retrieve the source column for given coordinates.
   * - Retrieve the totals column if this is a totals row
   * - Retrieve the source column if it's a proxied column
   * - Otherwise return the column at the given index
   * @param column Column index to get the source column from
   * @param row Row index to get the source column from
   */
  sourceColumn(column, row) {
    var totalsRow = this.totalsRow(row);
    if (totalsRow != null) {
      var _this$totals7, _this$totals$defaultO, _this$totals8, _this$totalsTable;
      var operation = (_this$totals7 = this.totals) === null || _this$totals7 === void 0 ? void 0 : _this$totals7.operationOrder[totalsRow];
      var defaultOperation = (_this$totals$defaultO = (_this$totals8 = this.totals) === null || _this$totals8 === void 0 ? void 0 : _this$totals8.defaultOperation) !== null && _this$totals$defaultO !== void 0 ? _this$totals$defaultO : AggregationOperation.SUM;
      var tableColumn = this.columns[column];

      // Find the matching totals table column for the operation
      // When there are multiple aggregations for the column, the column name will be the original name of the column with the operation appended afterward
      // When the the operation is the default operation OR there is only one operation for the column, then the totals column name is just the original column name
      var totalsColumn = (_this$totalsTable = this.totalsTable) === null || _this$totalsTable === void 0 ? void 0 : _this$totalsTable.columns.find(col => {
        var _this$totals9;
        return col.name === "".concat(tableColumn.name, "__").concat(operation) || (operation === defaultOperation || ((_this$totals9 = this.totals) === null || _this$totals9 === void 0 || (_this$totals9 = _this$totals9.operationMap[col.name]) === null || _this$totals9 === void 0 ? void 0 : _this$totals9.length) === 1) && col.name === tableColumn.name;
      });
      if (totalsColumn != null) {
        return totalsColumn;
      }
      // There may be cases were the totals table doesn't have a column, such as when there's a virtual column
    }
    return this.columns[column];
  }

  /**
   * Translate from the row in the model to a row in the totals table.
   * If the row is not a totals row, return null
   * @param y The row in the model to get the totals row for
   * @returns The row within the totals table if it's a totals row, null otherwise
   */
  totalsRow(y) {
    var _this$totals$operatio5, _this$totals0, _this$totals$showOnTo2, _this$totals1;
    var totalsRowCount = (_this$totals$operatio5 = (_this$totals0 = this.totals) === null || _this$totals0 === void 0 || (_this$totals0 = _this$totals0.operationOrder) === null || _this$totals0 === void 0 ? void 0 : _this$totals0.length) !== null && _this$totals$operatio5 !== void 0 ? _this$totals$operatio5 : 0;
    var showOnTop = (_this$totals$showOnTo2 = (_this$totals1 = this.totals) === null || _this$totals1 === void 0 ? void 0 : _this$totals1.showOnTop) !== null && _this$totals$showOnTo2 !== void 0 ? _this$totals$showOnTo2 : false;
    var totalsRow = showOnTop ? y : y - this.table.size;
    if (totalsRow >= 0 && totalsRow < totalsRowCount) {
      return totalsRow;
    }
    return null;
  }

  /**
   * Translate from the row in the model to a pending input row.
   * If the row is not a pending input row, return null
   * @param y The row in the model to get the pending row for
   * @returns The row within the pending input rows if it's a pending row, null otherwise
   */
  pendingRow(y) {
    if (!this.isEditable) {
      return null;
    }
    var pendingRow = y - this.floatingTopRowCount - this.table.size;
    if (pendingRow >= 0) {
      return pendingRow;
    }
    return null;
  }

  /**
   * Check if a row is a totals table row
   * @param y The row in the model to check if it's a totals table row
   * @returns True if the row is a totals row, false if not
   */
  isTotalsRow(y) {
    return this.totalsRow(y) != null;
  }

  /**
   * Check if a row is a pending input row
   * @param y The row in the model to check if it's a pending new row
   * @returns True if the row is a pending new row, false if not
   */
  isPendingRow(y) {
    return this.pendingRow(y) != null;
  }
  dataForCell(x, y) {
    var _this$row;
    return (_this$row = this.row(y)) === null || _this$row === void 0 ? void 0 : _this$row.data.get(x);
  }
  formatForCell(x, y) {
    var _this$dataForCell;
    return (_this$dataForCell = this.dataForCell(x, y)) === null || _this$dataForCell === void 0 ? void 0 : _this$dataForCell.format;
  }
  valueForCell(x, y) {
    var data = this.dataForCell(x, y);

    /* JS API current sets null values as undefined in some instances. This means 
    we need to nullish coaelesce so all undefined values from the API return null 
    since the data has been fetched. undefined is used to indicate the API has not 
    fetched data yet */
    if (data) {
      var _data$value;
      return (_data$value = data.value) !== null && _data$value !== void 0 ? _data$value : null;
    }
    return undefined;
  }
  copyViewportData(data) {
    if (data == null) {
      log.warn('invalid data!');
      return;
    }
    this.viewportData = this.extractViewportData(data);
    this.formattedStringData = [];
  }
  copyTotalsData(totalsData) {
    var _this$totals$defaultO2,
      _this$totals10,
      _this$totals11,
      _this = this;
    if (totalsData == null) {
      log.warn('invalid data!');
      return;
    }
    var columns = totalsData.columns,
      rows = totalsData.rows;
    if (rows.length !== 1) {
      log.error('Unexpected number of rows received for totals table, ignoring update');
      return;
    }
    var dataMap = new Map();
    var row = rows[0];
    var defaultOperation = (_this$totals$defaultO2 = (_this$totals10 = this.totals) === null || _this$totals10 === void 0 ? void 0 : _this$totals10.defaultOperation) !== null && _this$totals$defaultO2 !== void 0 ? _this$totals$defaultO2 : AggregationOperation.SUM;
    var operationMap = (_this$totals11 = this.totals) === null || _this$totals11 === void 0 ? void 0 : _this$totals11.operationMap;
    var _loop = function _loop() {
      var _operationMap$name$, _operationMap$name;
      var column = columns[c];
      var _column$name$split = column.name.split('__'),
        _column$name$split2 = _slicedToArray(_column$name$split, 2),
        name = _column$name$split2[0],
        _column$name$split2$ = _column$name$split2[1],
        operation = _column$name$split2$ === void 0 ? (_operationMap$name$ = operationMap === null || operationMap === void 0 || (_operationMap$name = operationMap[name]) === null || _operationMap$name === void 0 ? void 0 : _operationMap$name[0]) !== null && _operationMap$name$ !== void 0 ? _operationMap$name$ : defaultOperation : _column$name$split2$;
      if (!dataMap.has(operation)) {
        dataMap.set(operation, {
          data: new Map()
        });
      }
      var _dataMap$get = dataMap.get(operation),
        rowData = _dataMap$get.data;
      var columnIndex = _this.columns.findIndex(col => col.name === name);
      rowData.set(columnIndex, {
        value: row.get(column),
        format: row.getFormat(column)
      });
    };
    for (var c = 0; c < columns.length; c += 1) {
      _loop();
    }
    log.debug2('copyTotalsData', dataMap);
    this.totalsDataMap = dataMap;
    this.formattedStringData = [];
  }

  /**
   * Use this as the canonical column index since things like layoutHints could have
   * changed the column order.
   */
  getColumnIndexByName(name) {
    return this.getColumnIndicesByNameMap(this.columns).get(name);
  }
  /**
   * Copies all the viewport data into an object that we can reference later.
   * @param data The data to copy from
   */
  extractViewportData(data) {
    var newData = {
      offset: data.offset,
      rows: []
    };
    var columns = data.columns;
    for (var r = 0; r < data.rows.length; r += 1) {
      var row = data.rows[r];
      var newRow = this.extractViewportRow(row, columns);
      newData.rows.push(newRow);
    }
    return newData;
  }
  extractViewportRow(row, columns) {
    var data = new Map();
    for (var c = 0; c < columns.length; c += 1) {
      var column = columns[c];
      var index = this.getColumnIndexByName(column.name);
      data.set(index !== null && index !== void 0 ? index : column.name, {
        value: row.get(column),
        format: row.getFormat(column)
      });
    }
    return {
      data
    };
  }
  closeSubscription() {
    log.debug2('closeSubscription', this.subscription);
    if (this.subscription) {
      this.subscription.close();
      this.subscription = null;
    }
    this.setViewport.cancel();
    this.applyViewport.cancel();
  }
  get filter() {
    return this.table.filter;
  }
  set filter(filter) {
    this.closeSubscription();
    this.table.applyFilter(filter);
    this.applyViewport();
  }
  get formatter() {
    return this.irisFormatter;
  }
  set formatter(formatter) {
    this.irisFormatter = formatter;
    this.formattedStringData = [];
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.FORMATTER_UPDATED));
  }
  get columnAlignmentMap() {
    return this.irisColumnAlignmentMap;
  }
  set columnAlignmentMap(columnAlignmentMap) {
    this.irisColumnAlignmentMap = columnAlignmentMap;
  }
  displayString(value, columnType) {
    var columnName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var formatOverride = arguments.length > 3 ? arguments[3] : undefined;
    return this.getCachedFormattedString(this.formatter, value, columnType, columnName, formatOverride);
  }
  get sort() {
    return this.table.sort;
  }
  set sort(sort) {
    this.closeSubscription();
    this.table.applySort(this.irisGridUtils.hydrateDhSort(this.columns, sort));
    this.applyViewport();
  }
  set totalsConfig(totalsConfig) {
    log.debug('set totalsConfig', totalsConfig);
    if (totalsConfig === this.totals) {
      // Totals already set, or it will be set when the next model actually gets set
      return;
    }
    this.totals = totalsConfig;
    this.formattedStringData = [];
    if (this.totalsTablePromise != null) {
      this.totalsTablePromise.cancel();
    }
    this.setTotalsTable(null);
    if (totalsConfig == null) {
      this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));
      return;
    }
    this.totalsTablePromise = PromiseUtils.makeCancelable(this.table.getTotalsTable(totalsConfig), table => table.close());
    this.totalsTablePromise.then(totalsTable => {
      this.totalsTablePromise = null;
      this.setTotalsTable(totalsTable);
    }).catch(err => {
      if (PromiseUtils.isCanceled(err)) {
        return;
      }
      log.error('Unable to set next totalsTable', err);
      this.totalsTablePromise = null;
      this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.REQUEST_FAILED, {
        detail: err
      }));
    });
  }
  setTotalsTable(totalsTable) {
    log.debug('setTotalsTable', totalsTable);
    if (this.totalsTable !== null) {
      if (this.listenerCount > 0) {
        this.removeTotalsListeners(this.totalsTable);
      }
      this.totalsTable.close();
    }
    this.totalsTable = totalsTable;
    this.totalsDataMap = null;
    if (this.listenerCount > 0 && this.totalsTable != null) {
      this.addTotalsListeners(this.totalsTable);
    }
  }
  applyBufferedViewport(viewportTop, viewportBottom, columns) {
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.VIEWPORT_UPDATED));
    log.debug2('applyBufferedViewport', viewportTop, viewportBottom, columns);
    if (this.subscription == null) {
      var _this$table$setViewpo;
      log.debug2('applyBufferedViewport creating new subscription');
      this.subscription = (_this$table$setViewpo = this.table.setViewport(viewportTop, viewportBottom, columns)) !== null && _this$table$setViewpo !== void 0 ? _this$table$setViewpo : null;
    } else {
      log.debug2('applyBufferedViewport using existing subscription');
      this.subscription.setViewport(viewportTop, viewportBottom, columns);
    }
  }
  snapshot(ranges) {
    var _arguments = arguments,
      _this2 = this;
    return _asyncToGenerator(function* () {
      var includeHeaders = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
      var formatValue = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : value => value;
      var consolidateRanges = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : true;
      if (_this2.subscription == null) {
        throw new Error('No subscription available');
      }
      var consolidated = consolidateRanges ? GridRange.consolidate(ranges) : ranges;
      if (!IrisGridUtils.isValidSnapshotRanges(consolidated)) {
        throw new Error("Invalid snapshot ranges ".concat(ranges));
      }

      // Need to separate out the floating ranges as they're from a different source
      var topFloatingRowsSet = new Set();
      var tableRanges = [];
      var bottomFloatingRowsSet = new Set();
      for (var i = 0; i < consolidated.length; i += 1) {
        var range = consolidated[i];
        assertNotNull(range.endRow);
        assertNotNull(range.startRow);
        // Get the rows that are in the top aggregations section
        for (var r = range.startRow; r <= range.endRow && r < _this2.floatingTopRowCount; r += 1) {
          topFloatingRowsSet.add(r);
        }

        // Separate out the range that is part of the actual table (ie. not the floating ranges, not aggregations)
        if (range.endRow >= _this2.floatingTopRowCount && range.startRow <= _this2.floatingTopRowCount + _this2.table.size) {
          tableRanges.push(new GridRange(range.startColumn, Math.min(Math.max(0, range.startRow - _this2.floatingTopRowCount)), range.endColumn, Math.min(Math.max(0, range.endRow - _this2.floatingTopRowCount), _this2.table.size - _this2.floatingTopRowCount)));
        }
        // Get the rows that are in the bottom aggregations section
        for (var _r = Math.max(range.startRow, _this2.floatingTopRowCount + _this2.table.size); _r <= range.endRow && _r < _this2.floatingTopRowCount + _this2.table.size + _this2.floatingBottomRowCount; _r += 1) {
          bottomFloatingRowsSet.add(_r);
        }
      }
      var columns = IrisGridUtils.columnsFromRanges(consolidated, _this2.columns);
      var result = [];
      if (includeHeaders) {
        result.push(columns.map(c => c.name));
      }
      var topFloatingRows = [...topFloatingRowsSet].sort();
      var _loop2 = function* _loop2() {
        var row = topFloatingRows[_i];
        var rowData = columns.map(column => {
          var index = _this2.getColumnIndexByName(column.name);
          assertNotNull(index);
          return formatValue(_this2.valueForCell(index, row), column);
        });
        if (includeHeaders) {
          rowData.push(_this2.textForRowFooter(row));
        }
        result.push(rowData);
      };
      for (var _i = 0; _i < topFloatingRows.length; _i += 1) {
        yield* _loop2();
      }
      if (tableRanges.length > 0) {
        var rangeSet = _this2.irisGridUtils.rangeSetFromRanges(tableRanges);
        var snapshot = yield _this2.subscription.snapshot(rangeSet, columns);
        result.push(...snapshot.rows.map(rowData => columns.map(column => formatValue(rowData.get(column), column))));
      }
      var bottomFloatingRows = [...bottomFloatingRowsSet].sort();
      var _loop3 = function* _loop3() {
        var row = bottomFloatingRows[_i2];
        var rowData = columns.map(column => {
          var index = _this2.getColumnIndexByName(column.name);
          assertNotNull(index);
          return formatValue(_this2.valueForCell(index, row), column);
        });
        if (includeHeaders) {
          rowData.push(_this2.textForRowFooter(row));
        }
        result.push(rowData);
      };
      for (var _i2 = 0; _i2 < bottomFloatingRows.length; _i2 += 1) {
        yield* _loop3();
      }
      return result;
    })();
  }

  /**
   * Get a text snapshot of the provided ranges
   * @param ranges The ranges to get the snapshot for
   * @param includeHeaders Whether to include the headers in the snapshot or not
   * @param formatValue Function for formatting the raw value into a string
   * @returns A formatted string of all the data, columns separated by `\t` and rows separated by `\n`
   */
  textSnapshot(ranges) {
    var _arguments2 = arguments,
      _this3 = this;
    return _asyncToGenerator(function* () {
      var includeHeaders = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : false;
      var formatValue = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : value => "".concat(value);
      log.debug2('textSnapshot', ranges, includeHeaders);
      var data = yield _this3.snapshot(ranges, includeHeaders, formatValue, false);
      return data.map(row => row.join('\t')).join('\n');
    })();
  }
  valuesTable(columns) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var table = null;
      try {
        table = yield _this4.table.copy();
        table.applyFilter([]);
        table.applySort([]);
        return yield table.selectDistinct(Array.isArray(columns) ? columns : [columns]);
      } finally {
        if (table != null) {
          table.close();
        }
      }
    })();
  }
  isColumnMovable(modelIndex, depth) {
    if (modelIndex < 0 || modelIndex >= this.columnCount) {
      return false;
    }

    // All groups are movable
    if (depth > 0) {
      return true;
    }
    var columnName = this.columns[modelIndex].name;
    if (this.frontColumns.includes(columnName) || this.backColumns.includes(columnName) || this.frozenColumns.includes(columnName) || !columnName) {
      return false;
    }
    return !this.isKeyColumn(modelIndex);
  }
  isColumnSortable(modelIndex) {
    var _this$columns$modelIn;
    return (_this$columns$modelIn = this.columns[modelIndex].isSortable) !== null && _this$columns$modelIn !== void 0 ? _this$columns$modelIn : true;
  }
  isKeyColumn(x) {
    return this.keyColumnSet.has(this.columns[x].name);
  }
  isValueColumn(x) {
    return this.valueColumnSet.has(this.columns[x].name);
  }
  isRowMovable() {
    return false;
  }
  isEditableRange(range) {
    var _range$endColumn;
    // Make sure we have an input table and a valid range
    if (this.inputTable == null || range.startRow == null || range.endRow == null) {
      return false;
    }

    // Check that the edit is in the editable range
    // If an input table has keyed columns, the non-key columns are always editable
    // If an input table does not have key columns, it is append only and existing rows cannot be editable
    // Pending rows are always editable
    var isPendingRange = this.isPendingRow(range.startRow) && this.isPendingRow(range.endRow);
    var isKeyColumnInRange = false;
    assertNotNull(range.startColumn);
    // Check if any of the columns in grid range are key columns
    var bound = (_range$endColumn = range.endColumn) !== null && _range$endColumn !== void 0 ? _range$endColumn : this.table.size;
    for (var column = range.startColumn; column <= bound; column += 1) {
      var isKey = this.isKeyColumn(column);
      var isValue = this.isValueColumn(column);
      if (!isKey && !isValue) {
        // If any column is not a key or value column, range is not editable
        return false;
      }
      if (isKey) {
        isKeyColumnInRange = true;
        break;
      }
    }
    if (!(isPendingRange || this.keyColumnSet.size !== 0 && !isKeyColumnInRange)) {
      return false;
    }
    return true;
  }
  isDeletableRange(range) {
    return this.inputTable != null && range.startRow != null && range.endRow != null && range.startRow >= this.floatingTopRowCount && range.startRow < this.floatingTopRowCount + this.table.size + this.pendingRowCount && range.endRow < this.floatingTopRowCount + this.table.size + this.pendingRowCount;
  }
  isEditableRanges(ranges) {
    return ranges.every(range => this.isEditableRange(range));
  }
  isDeletableRanges(ranges) {
    return ranges.every(range => this.isDeletableRange(range));
  }

  /**
   * @returns A range corresponding to the underlying table
   */
  getTableAreaRange() {
    return new GridRange(null, this.floatingTopRowCount, null, this.floatingTopRowCount + this.table.size - 1);
  }

  /**
   * @returns A range corresponding to the pending new rows
   */
  getPendingAreaRange() {
    return new GridRange(null, this.floatingTopRowCount + this.table.size, null, this.floatingTopRowCount + this.table.size + this.pendingNewRowCount - 1);
  }

  /**
   * Set value in an editable table
   * @param x The column to set
   * @param y The row to set
   * @param value The value to set
   * @returns A promise that resolves successfully when the operation is complete, or rejects if there's an error
   */
  setValueForCell(x, y, text) {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      // Cache the value in our pending string cache so that it stays displayed until our edit has been completed
      return _this5.setValueForRanges([new GridRange(x, y, x, y)], text);
    })();
  }

  /**
   * Set value in an editable table
   * @param ranges The ranges to set
   * @param value The values to set
   * @returns A promise that resolves successfully when the operation is complete, or rejects if there's an error
   */
  setValueForRanges(ranges, text) {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      if (!_this6.isEditableRanges(ranges)) {
        throw new Error("Edits contain uneditable ranges");
      }
      try {
        // Cache the value in our pending string cache so that it stays displayed until our edit has been completed
        var columnSet = new Set();

        // Formatted text for each column
        // Since there could be different formatting for each column, but the value will be the same across rows
        var formattedText = [];
        GridRange.forEachCell(ranges, (x, y) => {
          var column = _this6.columns[x];
          columnSet.add(column);
          if (formattedText[x] === undefined) {
            var value = _this6.tableUtils.makeValue(column.type, text, _this6.formatter.timeZone);
            formattedText[x] = value != null ? _this6.displayString(value, column.type, column.name) : null;
          }
          _this6.cachePendingValue(x, y, formattedText[x]);
        });

        // Take care of updates to the pending new area first, as they can be updated synchronously
        var pendingAreaRange = _this6.getPendingAreaRange();
        var pendingRanges = ranges.map(range => GridRange.intersection(pendingAreaRange, range)).filter(range => range != null).map(range => {
          assertNotNull(range);
          return GridRange.offset(range, 0, -(_this6.floatingTopRowCount + _this6.table.size));
        });
        if (pendingRanges.length > 0) {
          var newDataMap = new Map(_this6.pendingNewDataMap);
          GridRange.forEachCell(pendingRanges, (columnIndex, rowIndex) => {
            if (!newDataMap.has(rowIndex)) {
              newDataMap.set(rowIndex, {
                data: new Map()
              });
            }
            var column = _this6.columns[columnIndex];
            var row = newDataMap.get(rowIndex);
            assertNotNull(row);
            var rowData = row.data;
            var newRowData = new Map(rowData);
            var value = _this6.tableUtils.makeValue(column.type, text, _this6.formatter.timeZone);
            if (value != null) {
              newRowData.set(columnIndex, {
                value
              });
            } else {
              newRowData.delete(columnIndex);
            }
            if (newRowData.size > 0) {
              newDataMap.set(rowIndex, _objectSpread(_objectSpread({}, row), {}, {
                data: newRowData
              }));
            } else {
              newDataMap.delete(rowIndex);
            }
          });
          _this6.pendingDataMap = newDataMap;
        }
        _this6.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));
        var tableAreaRange = _this6.getTableAreaRange();
        var tableRanges = ranges.map(range => GridRange.intersection(tableAreaRange, range)).filter(range => range != null);
        if (tableRanges.length > 0) {
          var _this6$inputTable;
          // Get a snapshot of the full rows, as we need to write a full row when editing
          var data = yield _this6.snapshot(tableRanges.map(range => {
            var _range$startRow, _range$endRow;
            return new GridRange(null, (_range$startRow = range === null || range === void 0 ? void 0 : range.startRow) !== null && _range$startRow !== void 0 ? _range$startRow : null, null, (_range$endRow = range === null || range === void 0 ? void 0 : range.endRow) !== null && _range$endRow !== void 0 ? _range$endRow : null);
          }));
          var newRows = data.map(row => {
            var newRow = {};
            for (var c = 0; c < _this6.columns.length; c += 1) {
              newRow[_this6.columns[c].name] = row[c];
            }
            columnSet.forEach(column => {
              newRow[column.name] = _this6.tableUtils.makeValue(column.type, text, _this6.formatter.timeZone);
            });
            return newRow;
          });
          var result = yield (_this6$inputTable = _this6.inputTable) === null || _this6$inputTable === void 0 ? void 0 : _this6$inputTable.addRows(newRows);
          log.debug('setValueForRanges(', ranges, ',', text, ') set tableRanges', tableRanges, 'result', result);
        }

        // Add the changes to the formatted cache so it's still displayed until the update event is received
        // The update event could be received on the next tick, after the input rows have been committed,
        // so make sure we don't display stale data
        GridRange.forEachCell(ranges, (x, y) => {
          var cellText = formattedText[x];
          assertNotNull(cellText);
          _this6.cacheFormattedValue(x, y, cellText);
        });
      } catch (err) {
        log.error('Unable to set ranges', ranges, text, err);
        // Rethrow the error so it can be displayed by the UI
        throw new GridCommitError('Unable to set ranges', {
          ranges,
          text,
          cause: err
        });
      } finally {
        GridRange.forEachCell(ranges, (x, y) => {
          _this6.clearPendingValue(x, y);
        });
      }
    })();
  }
  setValues() {
    var _arguments3 = arguments,
      _this7 = this;
    return _asyncToGenerator(function* () {
      var edits = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : [];
      log.debug('setValues(', edits, ')');
      if (!edits.every(edit => {
        var _edit$column, _edit$row;
        return _this7.isEditableRange(GridRange.makeCell((_edit$column = edit.column) !== null && _edit$column !== void 0 ? _edit$column : edit.x, (_edit$row = edit.row) !== null && _edit$row !== void 0 ? _edit$row : edit.y));
      })) {
        throw new Error("Edits contain uneditable ranges");
      }
      try {
        var newDataMap = new Map(_this7.pendingNewDataMap);

        // Cache the display values
        edits.forEach(edit => {
          var _edit$column2, _edit$row2;
          var text = edit.text;
          var x = (_edit$column2 = edit.column) !== null && _edit$column2 !== void 0 ? _edit$column2 : edit.x;
          var y = (_edit$row2 = edit.row) !== null && _edit$row2 !== void 0 ? _edit$row2 : edit.y;
          var column = _this7.columns[x];
          var value = _this7.tableUtils.makeValue(column.type, text, _this7.formatter.timeZone);
          var formattedText = value != null ? _this7.displayString(value, column.type, column.name) : null;
          _this7.cachePendingValue(x, y, formattedText);

          // Take care of updates to the pending new area as well, as that can be updated synchronously
          var pendingRow = _this7.pendingRow(y);
          if (pendingRow != null) {
            if (!newDataMap.has(pendingRow)) {
              newDataMap.set(pendingRow, {
                data: new Map()
              });
            }
            var row = newDataMap.get(pendingRow);
            assertNotNull(row);
            var rowData = row.data;
            var newRowData = new Map(rowData);
            if (value != null) {
              newRowData.set(x, {
                value
              });
            } else {
              newRowData.delete(x);
            }
            if (newRowData.size > 0) {
              newDataMap.set(pendingRow, _objectSpread(_objectSpread({}, row), {}, {
                data: newRowData
              }));
            } else {
              newDataMap.delete(pendingRow);
            }
          }
        });
        _this7.pendingDataMap = newDataMap;

        // Send an update right after setting the pending map so the values are displayed immediately
        _this7.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));

        // Need to group by row...
        var rowEditMap = edits.reduce((rowMap, edit) => {
          var _edit$row3, _rowMap$get;
          var y = (_edit$row3 = edit.row) !== null && _edit$row3 !== void 0 ? _edit$row3 : edit.y;
          if (!rowMap.has(y)) {
            rowMap.set(y, []);
          }
          (_rowMap$get = rowMap.get(y)) === null || _rowMap$get === void 0 || _rowMap$get.push(edit);
          return rowMap;
        }, new Map());
        var ranges = GridRange.consolidate(edits.map(edit => {
          var _edit$column3, _edit$row4;
          return GridRange.makeCell((_edit$column3 = edit.column) !== null && _edit$column3 !== void 0 ? _edit$column3 : edit.x, (_edit$row4 = edit.row) !== null && _edit$row4 !== void 0 ? _edit$row4 : edit.y);
        }));
        var tableAreaRange = _this7.getTableAreaRange();
        var tableRanges = ranges.map(range => GridRange.intersection(tableAreaRange, range)).filter(range => range != null);
        if (tableRanges.length > 0) {
          var _this7$inputTable;
          // Get a snapshot of the full rows, as we need to write a full row when editing
          var data = yield _this7.snapshot(tableRanges.map(range => {
            assertNotNull(range);
            return new GridRange(null, range.startRow, null, range.endRow);
          }));
          var newRows = data.map((row, dataIndex) => {
            var rowIndex = null;
            var r = dataIndex;
            for (var i = 0; i < tableRanges.length; i += 1) {
              var range = tableRanges[i];
              assertNotNull(range);
              var rangeRowCount = GridRange.rowCount([range]);
              if (r < rangeRowCount) {
                assertNotNull(range.startRow);
                rowIndex = range.startRow + r;
                break;
              }
              r -= rangeRowCount;
            }
            var newRow = {};
            for (var c = 0; c < _this7.columns.length; c += 1) {
              newRow[_this7.columns[c].name] = row[c];
            }
            assertNotNull(rowIndex);
            var rowEdits = rowEditMap.get(rowIndex);
            if (rowEdits != null) {
              rowEdits.forEach(edit => {
                var _edit$column4;
                var column = _this7.columns[(_edit$column4 = edit.column) !== null && _edit$column4 !== void 0 ? _edit$column4 : edit.x];
                newRow[column.name] = _this7.tableUtils.makeValue(column.type, edit.text, _this7.formatter.timeZone);
              });
            }
            return newRow;
          });
          log.info('setValues setting tableRanges', tableRanges);
          var result = yield (_this7$inputTable = _this7.inputTable) === null || _this7$inputTable === void 0 ? void 0 : _this7$inputTable.addRows(newRows);
          log.info('setValues set tableRanges', tableRanges, 'SUCCESS', result);
        }

        // We've sent the changes to the server, but have not yet got an update with those changes committed
        // Add the changes to the formatted cache so it's still displayed until the update event is received
        // The update event could be received on the next tick, after the input rows have been committed,
        // so make sure we don't display stale data
        edits.forEach(edit => {
          var _edit$column5, _edit$row5;
          var text = edit.text;
          var x = (_edit$column5 = edit.column) !== null && _edit$column5 !== void 0 ? _edit$column5 : edit.x;
          var y = (_edit$row5 = edit.row) !== null && _edit$row5 !== void 0 ? _edit$row5 : edit.y;
          var column = _this7.columns[x];
          var value = _this7.tableUtils.makeValue(column.type, text, _this7.formatter.timeZone);
          var formattedText = value != null ? _this7.displayString(value, column.type, column.name) : null;
          _this7.cacheFormattedValue(x, y, formattedText);
        });
      } finally {
        edits.forEach(edit => {
          _this7.clearPendingValue(edit.column, edit.row);
        });
      }
    })();
  }
  commitPending() {
    var _this8 = this;
    return _asyncToGenerator(function* () {
      if (_this8.pendingNewDataMap.size <= 0) {
        throw new Error('No pending changes to commit');
      }
      try {
        var _this8$inputTable, _this8$viewport$botto, _this8$viewport;
        _this8.isSaveInProgress = true;
        var newRows = [];
        _this8.pendingNewDataMap.forEach(row => {
          var newRow = {};
          row.data.forEach((_ref2, columnIndex) => {
            var value = _ref2.value;
            var columnName = typeof columnIndex === 'string' ? columnIndex : _this8.columns[columnIndex].name;
            newRow[columnName] = value;
          });
          newRows.push(newRow);
        });
        var result = yield (_this8$inputTable = _this8.inputTable) === null || _this8$inputTable === void 0 ? void 0 : _this8$inputTable.addRows(newRows);
        log.debug('commitPending()', _this8.pendingNewDataMap, 'result', result);
        _this8.pendingNewDataMap = new Map();
        _this8.pendingNewRowCount = Math.max(0, ((_this8$viewport$botto = (_this8$viewport = _this8.viewport) === null || _this8$viewport === void 0 ? void 0 : _this8$viewport.bottom) !== null && _this8$viewport$botto !== void 0 ? _this8$viewport$botto : 0) - _this8.table.size);
        _this8.formattedStringData = [];
        _this8.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.PENDING_DATA_UPDATED));
      } finally {
        _this8.isSaveInProgress = false;
      }
    })();
  }
  editValueForCell(column, row) {
    var _this$textValueForCel;
    return (_this$textValueForCel = this.textValueForCell(column, row)) !== null && _this$textValueForCel !== void 0 ? _this$textValueForCel : '';
  }
  delete(ranges) {
    return _asyncToGenerator(function* () {
      throw new Error('Delete not implemented');
    })();
  }
  isValidForCell(x, y, value) {
    try {
      var column = this.columns[x];
      this.tableUtils.makeValue(column.type, value, this.formatter.timeZone);
      return true;
    } catch (e) {
      return false;
    }
  }
}
_defineProperty(IrisGridTableModelTemplate, "ROW_BUFFER_PAGES", 1);
export default IrisGridTableModelTemplate;
//# sourceMappingURL=IrisGridTableModelTemplate.js.map